import { parseText } from '@/utils/parseText';
import { ArrowLinkIcon } from '@/atoms/Icons';
import styles from './FooterLinks.module.scss';
import Link from 'next/link';
import cn from 'classnames';

type FooterLinkProps = {
  href: string;
  text: string;
};

export function FooterLink({ text, href }: FooterLinkProps) {
  return (
    <Link className={styles.link} key={text} href={href}>
      <span className={cn(styles.title, 'custom-footer-link')}>
        {parseText(text)}
      </span>
      <ArrowLinkIcon staticArrow />
    </Link>
  );
}
